import { action } from 'typesafe-actions'
import { IInternetPackage } from '../../services/api/InternetPackage'
import { InternetPackageActionTypes } from './types'

export const FetchInternetPackage = (data: IInternetPackage) => action(InternetPackageActionTypes.FETCH_INTERNET_PACKAGE_TYPES, data)

export const SetInternetPackage = (data: IInternetPackage) => action(InternetPackageActionTypes.SET_INTERNET_PACKAGE_TYPES, data)

export const FetchError = () => action(InternetPackageActionTypes.FETCH_ERROR)

export const FetchModal = (data: boolean) => action(InternetPackageActionTypes.FETCH_MODAL, data)
